  <template >
  <div>
  <div>
  <div class="formPosition">
    <v-card style="margin:auto;" width="1200" >
      <v-overlay :value="progresso_overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    <v-card-title style="background-color:#006699;color:white;"></v-card-title>
     <v-toolbar flat color="white">

          <v-divider class="mx-8" inset vertical></v-divider>
          <v-toolbar-title>Definição do Plano financeiro anolectivo / Semestre</v-toolbar-title>
          <v-divider class="mx-8" inset vertical></v-divider>
          <!--  search  -->
          <div class="flex-grow-1"></div>
        </v-toolbar>
        <v-card>
           <v-card-text>
            <v-expansion-panels focusable>
              <v-expansion-panel>
                  <v-expansion-panel-header style="background-color:#006699;color:white;border-bottom:1px solid white;">Anolectivo <v-icon style="margin-left:-1000px;color:white;">calendar_today</v-icon></v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card>
                      <v-card-title>Selecione o anolectivo actual</v-card-title>
                       <v-card-text>
                          <v-row>
                             <v-col md="5">
                               <v-combobox
                                 v-model="editedItem.anolectivo"
                                 :items="anoslectivos"
                                 item-text="descricao"
                                 item-value="descricao"
                                 outlined
                                 return-object
                                 label="Selecione ao anolectivo"
                                 @change="selecionaAnolectivo()"
                               >
                               <template v-slot:item="{ item }">
                                  <v-list-item-avatar v-if="item.icone" color="indigo" class="headline font-weight-light white--text">
                                    <v-btn icon fab><v-icon style="color:white;">add</v-icon></v-btn>
                                  </v-list-item-avatar>
                                  <v-list-item-content>
                                    <v-list-item-title v-text="item.descricao"></v-list-item-title>
                                  </v-list-item-content>
                                </template>
                              </v-combobox>
                             </v-col>
                             <v-col md="7">
                              </v-col>
                              <v-col md="12">
                                 <span   style="font-size:16px;font-weight:bold;color:red">Att:</span><span> O Plano financeiro que está a definir, será configurado para o anolectivo <span style="font-weight:bold;font-size:15px;">{{(editedItem.anolectivo !== null)?editedItem.anolectivo.descricao:''}} </span> </span>
                              </v-col>
                                <v-row v-if="editedItem.anolectivo !== null && !isEnsinoSuperior">
                                  
                            <v-col md="4">
                              <v-card>
                               <v-list>
                                  <v-subheader>Meses</v-subheader>
                                  <hr>
                                <v-list-item
                                  v-for="item in mesesLista"
                                  :key="item.id"
                                  >
                                    <v-list-item-content>
                                      <v-list-item-title>{{item.descricao}}</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                      <v-btn icon @click="additem(item)">
                                        <v-icon color="grey lighten-1">arrow_forward</v-icon>
                                      </v-btn>
                                    </v-list-item-action>
                                  </v-list-item>
                              </v-list>
                              </v-card>
                            </v-col>
                            <v-col md="1">
                               <v-btn class="center-btn1" @click="addTableMeses()" color="primary" fab small>
                                 <v-icon>arrow_forward</v-icon>
                               </v-btn>
                               <v-btn class="center-btn2" @click="removeMeses()" color="primary" fab small>
                                 <v-icon>arrow_back</v-icon>
                               </v-btn>
                            </v-col>
                            <v-col md="6">
                              <v-card v-if="mesesSelecionados.length">
                               <v-list lines="one">
                                  <v-subheader>Meses selecionados</v-subheader>
                                  <hr>
                                <v-list-item
                                  v-for="(item,i) in mesesSelecionados"
                                  :key="item.id"
                                  >
                                    <v-list-item-content>
                                      <v-list-item-title>{{i+1}}º  {{item.descricao}}</v-list-item-title>
                                    </v-list-item-content>
                                     <v-list-item-action>
                                      <v-btn icon @click="removeitem(item)">
                                        <v-icon color="grey lighten-1">arrow_back</v-icon>
                                      </v-btn>
                                    </v-list-item-action>
                                  </v-list-item>
                              </v-list>
                              </v-card>
                            </v-col>
                          </v-row>
                              </v-col>
                          </v-row>
                       </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel v-if="isEnsinoSuperior">
                  <v-expansion-panel-header style="background-color:#006699;color:white;border-bottom:1px solid white;">Semestre <v-icon style="margin-left:-1000px;color:white;">calendar_month</v-icon></v-expansion-panel-header>
                  <v-expansion-panel-content>
                   <v-card>
                      <v-card-title>Selecione o semestre actual</v-card-title>
                       <v-card-text>
                        <hr style="border-bottom:1px solid rgba(234, 226, 230, 0.1);">
                           <v-row>
                             <v-col md="12">
                              <v-switch
                                v-model="editedItem.semestre1"
                                :label="`Iº Semestre`"
                                @change="changeSemestre1()"
                              ></v-switch>
                             </v-col>
                              <v-col md="12">
                              <v-switch
                                v-model="editedItem.semestre2"
                                :label="`IIº Semestre`"
                                @change="changeSemestre2()"
                              ></v-switch>
                             </v-col>
                          </v-row>
                          <hr>
                          <v-card-title>Selecione o intervalo de meses</v-card-title>
                          <v-row>
                            <v-col md="4">
                              <v-card>
                               <v-list>
                                  <v-subheader>Meses</v-subheader>
                                  <hr>
                                <v-list-item
                                  v-for="item in mesesLista"
                                  :key="item.id"
                                  >
                                    <v-list-item-content>
                                      <v-list-item-title>{{item.descricao}}</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                      <v-btn icon @click="additem(item)">
                                        <v-icon color="grey lighten-1">arrow_forward</v-icon>
                                      </v-btn>
                                    </v-list-item-action>
                                  </v-list-item>
                              </v-list>
                              </v-card>
                            </v-col>
                            <v-col md="1">
                               <v-btn class="center-btn1" @click="addTableMeses()" color="primary" fab small>
                                 <v-icon>arrow_forward</v-icon>
                               </v-btn>
                               <v-btn class="center-btn2" @click="removeMeses()" color="primary" fab small>
                                 <v-icon>arrow_back</v-icon>
                               </v-btn>
                            </v-col>
                            <v-col md="6">
                              <v-card v-if="mesesSelecionados.length">
                               <v-list lines="one">
                                  <v-subheader>Meses selecionados</v-subheader>
                                  <hr>
                                <v-list-item
                                  v-for="(item,i) in mesesSelecionados"
                                  :key="item.id"
                                  >
                                    <v-list-item-content>
                                      <v-list-item-title>{{i+1}}º  {{item.descricao}}</v-list-item-title>
                                    </v-list-item-content>
                                     <v-list-item-action>
                                      <v-btn icon @click="removeitem(item)">
                                        <v-icon color="grey lighten-1">arrow_back</v-icon>
                                      </v-btn>
                                    </v-list-item-action>
                                  </v-list-item>
                              </v-list>
                              </v-card>
                            </v-col>
                          </v-row>
                       </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
           </v-card-text>
           <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green"
              style="color:white;"
              :disabled="!planovalid"
              @click="salvarPlanoFinanceiro()"
            >
              Guardar
            </v-btn>
          </v-card-actions>
        </v-card>
    </v-card>
  </div>

</div>
</div>
</template>
<script>
import Swal from 'sweetalert2'
import axios from '../../plugins/axios'
import utilitarios from '../../plugins/utilitarios'
const ls = require('local-storage')
export default {

  data: () => ({
    arrayferiados: [],
    mesesSelecionados: [],
    mesesLista: utilitarios.MonthsOfYear(),
    headers: [
      {
        text: 'Mês',
        align: 'left',
        sortable: false,
        value: 'fkMes'
      },
      { text: 'Ordem de Cobrança', value: 'ordemCobranca' },
      { text: 'Data', value: 'p1' },
      { text: 'Data criação', value: 'data_' },
      { text: 'Autor', value: 'autor' },
      { text: 'Ação', value: 'action' }
    ],
    switch1: '',
    dialogoNovoAno: false,
    overlayAnolectivo: false,
    dataMultaSelected: null,
    utilitarios: utilitarios,
    objecto: null,
    progresso_overlay: false,
    overlayEliminar: false,
    searchInDb: '',
    anoslectivos: [],
    multasPrazo: [],
    items: [
      { descricao: 'Novo anolectivo', icone: 'add', idanolectivo: -1 }
    ],
    dialogEditar: false,
    dialogoElimar: false,
    overlay: false,
    isLoading: false,
    dialog: false,
    overlay: false,
    valid: true,
    meses: [],
    maxYear: '',
    minYear: '',
    editedItem: {
      month: null,
      date1: '',
      autor: ls.get('nomeUsuario'),
      id: 0,
      semestre1: true,
      semestre2: false,
      anolectivo: null,
      novoAnolectivo: ''
    },
    defaultItem: {
      month: null,
      date1: '',
      autor: ls.get('nomeUsuario'),
      id: 0,
      semestre1: true,
      semestre2: false,
      anolectivo: null,
      novoAnolectivo: ''
    },
    multaObject: null,
    ruleRequired: [value => !!value || 'campo obrigatorio']
  }),

  computed: {
    mesesAPagar () {
      return ls.get('meses')
    },
    anolectivoActual () {
      return ls.get('anolectivo')
    },
    planovalid () {
      return this.editedItem.anolectivo !== null && (this.editedItem.semestre1 === true || this.editedItem.semestre2 === true) && this.mesesSelecionados.length
    },
    isEnsinoSuperior(){
      return ls.get('nivel') === 2
    }
  },

  created () {
    this.initializeAnolectivo()
  },

  methods: {

    async initializeAnolectivo () {
      try {
        this.anoslectivos = await axios.get('/listarAnolectivos').then((res) => res.data)
      } catch (error) {
        Swal.fire('Informação', 'Ocorreu um erro durante o carregamento dos anolectivos', 'error')
      }
    },

    async salvarPlanoFinanceiro () {
      try {
        this.progresso_overlay = true
        let params =
          {
            meses: this.mesesSelecionados,
            anolectivo: this.editedItem.anolectivo,
            semestre: (this.isEnsinoSuperior)?((this.editedItem.semestre1) ? 1 : 2):null,
            autor: ls.get('nomeUsuario')
          }
        let result = await axios.post('/planoFinanceiroSave', params).then((res) => res.data)
        if (result.affectedRows >= 1) {
          Swal.fire('Informação', 'Plano financeiro definido com sucesso', 'success')
          this.mesesSelecionados = []
        } else {
          Swal.fire('Informação', 'Ocorreu um erro ao tentar efectuar a operação', 'error')
        }
      } catch (error) {
        Swal.fire('Informação', 'Ocorreu um erro ao tentar efectuar a operação', 'error')
      } finally {
        this.progresso_overlay = false
      }
    },

    additem (item) {
      let index = this.mesesLista.indexOf(item)
      this.mesesSelecionados.push(item)
      this.mesesLista.splice(index, 1)
    },

    removeitem (item) {
      let index = this.mesesSelecionados.indexOf(item)
      this.mesesLista.unshift(item)
      this.mesesSelecionados.splice(index, 1)
    },

    addTableMeses () {
      if (this.mesesLista.length) {
        let mes = this.mesesLista.shift()
        this.mesesSelecionados.push(mes)
      }
    },

    removeMeses () {
      if (this.mesesSelecionados.length) {
        let mes = this.mesesSelecionados.pop()
        this.mesesLista.unshift(mes)
      }
    },

    changeSemestre1 () {
      if (this.editedItem.semestre1) { this.editedItem.semestre2 = false } else { this.editedItem.semestre1 = true }
    },

    changeSemestre2 () {
      if (this.editedItem.semestre2) { this.editedItem.semestre1 = false } else { this.editedItem.semestre2 = true }
    },

    close () {
      this.editedItem.anolectivo = ''
      this.dialogoNovoAno = false
    },

    selecionaAnolectivo () {
      if (this.editedItem.anolectivo.idanolectivo === -1) {
        this.dialogoNovoAno = true
        this.editedItem.anolectivo = null
      }
    },

    async NovoAnolectivo () {

    },

    async saveAnolectivo () {

    }

  }

}
</script>

<style scoped>
.bg {
 color:green;
 background: red
}

.center-btn1{
   margin-top:150px;
   color:white;
}
.center-btn2{
  margin-top:10px;
   color:white;
}
</style>
